import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";

export default class LoginHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "login":
                return this.handleLogin(model, params);
            case "login/confirm":
                return this.handleConfirm(model, params);
            case "login/cancel":
                return this.handleCancel(model, params);
            default:
                return model;
        }
    }

    private handleLogin(model: DiscussionModel, type: number): DiscussionModel {
        model = model.showModalLogin(type);
        return model;
    }

    private handleConfirm(model: DiscussionModel, params: any): DiscussionModel {

        // TODO: Redirect to login

        const loginUrl = model.getLogin();
        const baseUrl = location.protocol + "//" + location.host + location.pathname + "#diskusia";
        const url = loginUrl + "?return=" + encodeURIComponent(baseUrl) + "&info=1";

        window.setTimeout(() => {
            location.assign(url);
        }, 1);

        model = model.hideModalLogin();
        return model;
    }

    private handleCancel(model: DiscussionModel, params: any): DiscussionModel {
        model = model.hideModalLogin();
        return model;
    }

}